export default "__VITE_ASSET__BBywrVe2__"